export default __webpack_public_path__ + "static/media/one.fe20c8d2.png";